import { render, staticRenderFns } from "./AdGuardTopDomains.vue?vue&type=template&id=2030922f"
import script from "./AdGuardTopDomains.vue?vue&type=script&lang=js"
export * from "./AdGuardTopDomains.vue?vue&type=script&lang=js"
import style0 from "./AdGuardTopDomains.vue?vue&type=style&index=0&id=2030922f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports